import React, { useState, useEffect } from 'react';
import AgendaMobile from './agendaMobile';
import AgendaWeb from './agendaWeb';


const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};


const AgendaRouter = () => {
  const width = useWindowWidth();

  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <AgendaMobile /> : <AgendaWeb />;
};

export default AgendaRouter;